const checkIfValidDateUsingNaN = (DateObject) => {
    return !isNaN(DateObject);
};

export default checkIfValidDateUsingNaN;
